// @flow
import React from 'react';
import * as css from './Hero.module.css';
import { useSelector } from 'react-redux';
import { isComviqCustomer } from '../../helpers/customerTypeHelpers';

type Props = {
  title?: String,
  text?: String,
  hasAvailablePromotion: boolean,
  promotionText?: String,
};

const Hero = ({ title, text, hasAvailablePromotion, promotionText }: Props) => {
  const customerType = useSelector((state) => state.app.customerType);
  const isComviq = isComviqCustomer(customerType);

  if (!customerType) return <></>;

  return (
    <>
      <div>
        <div className={`${css.hero}`}>
          {isComviq &&
            (title ? (
              <>
                <h1 className={css.title}>{title}</h1>
                {!!text && <p className={css.text}>{text}</p>}
              </>
            ) : (
              <>
                <h1 className={css.title}>Smartwatch</h1>
                <p className={css.text}>Tilläggsabonnemang</p>
              </>
            ))}
          {hasAvailablePromotion && <div className={css.offer}>{promotionText ? promotionText : 'En fri månad'}</div>}
        </div>
      </div>
    </>
  );
};

export default React.memo(Hero);
